import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Spinner } from 'lp-components'
import useAuth from 'components/auth/useAuth'
import { selectors as membershipsSelectors } from 'memberships/reducer'
import * as membershipsActions from 'memberships/actions'
import * as apiActions from 'api-actions'
import { AllMembershipsType } from 'types'
import { getAccountIdentifier } from 'config'
import { withApiAuth } from 'utils'

const propTypes = {
  allMemberships: AllMembershipsType,
  children: PropTypes.node.isRequired,
  clearAllMemberships: PropTypes.func.isRequired,
  fetchAllMembershipsForAccount: PropTypes.func.isRequired,
}

function ApplicationPrefillProvider({
  allMemberships = null,
  children,
  clearAllMemberships,
  fetchAllMembershipsForAccount,
}) {
  const { isAuthenticated, user } = useAuth()
  const accountId = getAccountIdentifier(user)
  const isLoading = isAuthenticated && accountId && allMemberships == null

  useEffect(() => {
    if (isLoading) fetchAllMembershipsForAccount(accountId)
  }, [accountId, fetchAllMembershipsForAccount, isLoading])

  // Clears stale dashboard data on unmount so the Unfound Membership UI
  // doesn't flash next time. Kept in its own effect — merging with the
  // fetch effect would clear on every `isLoading` toggle and loop.
  useEffect(() => () => clearAllMemberships(), [clearAllMemberships])

  if (isLoading) return <Spinner />
  return children
}

ApplicationPrefillProvider.propTypes = propTypes

function mapStateToProps(state) {
  return {
    allMemberships: membershipsSelectors.allMemberships(state),
  }
}

const mapDispatchToProps = {
  clearAllMemberships: membershipsActions.clearAllMemberships,
}

const mapApiAuthToProps = {
  fetchAllMembershipsForAccount: apiActions.fetchAllMembershipsForAccount,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withApiAuth(mapApiAuthToProps),
)(ApplicationPrefillProvider)
